<template >
  <div>
    <ValidationObserver ref="observer3" v-slot="{ valid }" @submit.prevent="valid(handleSubmit)">
      <!-- <form @submit.prevent="passes(handleSubmit)"> -->
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>outlined_flag</md-icon>
        </div>
        <h4 class="title">Request An ATS #: Sign and Complete</h4>
      </md-card-header>

      <md-card-content class="md-layout start-inputs">
        <md-progress-bar
          class="md-primary md-layout-item md-size-100"
          :md-value="card3amt"
        ></md-progress-bar>
        <!-- <ATSTerms v-bind:infotab="false"/>
        <ValidationProvider name="atsterms" rules="required" v-slot="{ passed, failed }" class="md-layout-item md-size-100">
          <md-checkbox v-model="request.terms" required :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            I agree to the terms and conditions
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-checkbox>
        </ValidationProvider> -->
        <!-- <p class="sign-label">Sign to agree to the SafeCore Terms and Conditions</p>
        <SigPad v-on:saveSig="saveSig" /> -->
        <ValidationProvider name="companyname" rules="required" v-slot="{ passed, failed }" class="md-layout-item md-size-100">
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Company Name</label>
            <md-input v-model="request.signed_company_name" type="text"></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <ValidationProvider name="username" rules="required" v-slot="{ passed, failed }" class="md-layout-item md-size-100">
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>First and Last Name</label>
            <md-input v-model="request.signed_user_name" type="text"></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>
      <md-card-actions md-alignment="right">
        <p v-if="notValid" class="required-fields">Please fill in required fields</p>
        <md-progress-spinner v-if="isLoading == true" md-mode="indeterminate" class="md-accent ats-spin" :md-diameter="30" :md-stroke="3"></md-progress-spinner>
        <md-button class="md-info prev-button" v-on:click="prevCard()">Previous</md-button>
        <md-button class="md-success start-ats-p" v-on:click="handleSubmit()" :disabled="clickedOnce">Request SafeCore-ATS/Start Project</md-button>

      </md-card-actions>
    </md-card>
  <!-- </form> -->
</ValidationObserver>
  </div>
</template>
<script>
import ATSTerms from "@/pages/Dashboard/ProjectPages/Components/ATSTerms.vue";
// import SigPad from "@/pages/Dashboard/ProjectPages/Components/SigPad.vue";

export default {
  components: {
    // ATSTerms,
    // SigPad,
  },
  props: ['request', 'existingaddress'],
  data() {
    return {
      card3amt: 90,
      notValid: false,
      clickedOnce: false,
      isLoading: false,
      checkForSig: false,
    }
  },
  methods: {
    prevCard() {
      // console.log(this.existingaddress);
      this.$emit("prev", 3);
    },
    async handleSubmit() {
      this.clickedOnce = true;
      this.isLoading = true;
      const isValid = await this.$refs.observer3.validate();
      if (isValid) {
        this.notValid = false;
        this.$emit("submit");
      } else {
        this.isLoading = false;
        this.notValid = true;
        this.clickedOnce = false;
      }
    },
    // saveSig(data) {
    //   this.request.customer_signature = data;
    //   this.checkForSig = true;
    // }
  }
}
</script>
<style lang="scss">
.ats-spin {
  margin-right: 10px;
}
.sign-label {
  margin: 0;
  display: inline-block;
  display: block;
  width: 100%;
}
@media (max-width: 500px){
  .start-ats-p {
    font-size: 10px;
  }
}
@media (max-width: 768px){
  .start-project .md-card .md-card-actions{
    flex-direction: column;
  }
}

</style>
